<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :label="null"
    :help="true"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', newValue)
    },
  },
}
</script>
